import React from "react";
import style from "./style.module.css";
import deliveryPartner from "../../../assets/images/delivery_partner.webp";
import team from "../../../assets/images/team.webp";
import mayank from "../../../assets/images/mayank.webp";
import gaurav from "../../../assets/images/gaurav.webp";
import yash from "../../../assets/images/yash.webp";
import Navbar from "../../../components/atoms/Navbar";
import logo from "../../../assets/images/blitz_logo.svg";

const founderDetails = [
  {
    img: mayank,
    name: "Mayank Varshney",
    role: "Cofounder & CEO",
    title: "On-Time Delivery Expert",
  },
  {
    img: yash,
    name: "Yash Sharma",
    role: "Cofounder & CBO",
    title: "Partnerships Expert",
  },
  {
    img: gaurav,
    name: "Gaurav Piyush",
    role: "Cofounder & CTO",
    title: "Technology Expert",
  },
];

const AboutUs = () => {
  return (
    <div>
      <Navbar noLogo={false} logo={logo} />
      <section className={style.sectionContainer}>
        <div className={style.flexContainer}>
          <div className={style.aboutTextContainer}>
            <h1 className={style.heading}>About Blitz</h1>
            <p className={style.paragraph}>
              Blitz is a new-age logistics platform built for speed,
              intelligence, & reliability. <br /> Empowering brands & businesses
              with 60-minute pickups, dark store services, & SDD across India
            </p>
          </div>
          <div className={style.imageContainer}>
            <img
              src={deliveryPartner}
              className={style.fullWidthImage}
              alt="deliveryPartner"
            />
          </div>
        </div>
      </section>

      <section className={style.sectionContainer}>
        <div className={style.flexContainer}>
          <div className={style.missionContainer}>
            <h3 className={style.subHeading}>Mission</h3>
            <p className={style.textBlock}>
              To enable businesses of every size to scale faster with
              intelligent, on-demand logistics solutions — blending speed,
              technology, and human commitment.
            </p>
          </div>

          <div className={style.visionContainer}>
            <h3 className={style.subHeading}>Vision</h3>
            <p className={style.textBlock}>
              To enable businesses of every size to scale faster with
              intelligent, on-demand logistics solutions — blending speed,
              technology, and human commitment.
            </p>
          </div>
        </div>
      </section>

      <section className={style.sectionContainer}>
        <h3 className={style.teamHeading}>Meet the Team</h3>
        <div className={style.teamImageContainer}>
          <img src={team} alt="meet_the_team" className={style.teamImage} />
        </div>

        <div className={style.membersContainer}>
          {founderDetails?.map((member, index) => (
            <div key={index} className={style.memberCard}>
              <div className={style.avatarContainer}>
                <img
                  src={member.img}
                  alt={member.name}
                  className={style.avatar}
                />
              </div>
              <div className={style.memberDetails}>
                <h2 className={style.memberName}>{member.name}</h2>
                <p className={style.memberRole}>{member.role}</p>
                <p className={style.memberTitle}>{member.title}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
